import _ from 'lodash';
import getScrollTop from '../get-scroll-top';
import breakpoints from '../breakpoints';

export default class VideoSwoosher {
  constructor($sidebarVideos) {
    this.$sidebarVideos = $sidebarVideos;
    this.videos = [];
    this.useIosScrollWorkaround = /webkit.*mobile/i.test(navigator.userAgent);

    $(window).on('scroll', _.throttle(
      () => {
        if (this.enabled) this.onScroll();
        setTimeout(() => this.enabled && this.onScroll(), 100);
      },
      1000 / 60,
      {
        leading: true,
        trailing: true,
      },
    ));
    $(window).on('resize', _.throttle(
      () => {
        if (this.enabled) this.stickSidebarVideos();

        // Sometimes the offset seems to update after the last resize event,
        // making the left offset janky, so call this again in 100ms
        setTimeout(() => this.enabled && this.stickSidebarVideos(), 100);
      },
      1000 / 60,
      {
        leading: true,
        trailing: true,
      },
    ));

    this.enable();
  }

  enable() {
    if (this.enabled) return;

    this.enabled = true;
    this.onScroll();
  }

  disable() {
    if (!this.enabled) return;

    this.videos
      .filter(x => x.swooshed)
      .forEach(x => this.swooshIn(x));
    this.enabled = false;
  }

  // video: SwooshableVideo
  register(video) {
    video.swoosher = this;
    this.videos.push(video);
  }

  onScroll() {
    this.videos.forEach(video => video.onScroll());
    this.stickSidebarVideos();
  }

  swooshSidebar() {
    this.swooshSidebarVideos();

    // calculate and animate the sidebar height
    const height = (() => {
      const swooshedVideos = this.videos.filter(video => video.swooshed);

      if (swooshedVideos.length === 0) return 0;

      const firstVideo = swooshedVideos[0];
      const lastVideo = swooshedVideos[swooshedVideos.length - 1];

      return lastVideo.swooshOutPosition.top
        - firstVideo.swooshOutPosition.top
        + lastVideo.swooshOutPosition.height
        + 12;
    })();

    this.$sidebarVideos.animate({ height });
  }

  optimizeSidebarVideoOffset() {
    const intercomIconDimension = 80;
    const vw = breakpoints.getViewportWidth();
    const clientRect = this.$sidebarVideos.get(0).getClientRects()[0];
    if (clientRect) {
      // If we have enough room on the right for intercom icon, we sit at the
      // bottom offset as intercom icon, otherwise, sit on top of intercom
      const bottomOffset = vw - clientRect.right >= intercomIconDimension ? 40 : 100;
      this.$sidebarVideos.css('bottom', `${bottomOffset}px`);
    }
  }

  setSidebarVideoPositions() {
    const swooshedVideos = this.videos.filter(video => video.swooshed);
    const offset = this.$sidebarVideos.offset();
    const scrollTop = getScrollTop();
    // NOTE iOS has a strange bug where during a scroll, this.$sidebarVideos.offset().top doesn't
    // update on each event, which makes the video stick to the content instead of the sidebar.
    // So, brute force the video div to stick to 122px from the top on iOS only. This is edge-casey
    // but better than it getting stuck :-(
    const initialTop = this.useIosScrollWorkaround
      ? 122
      : offset.top - scrollTop + 34;

    swooshedVideos.reduce((currentTop, video) => {
      video.swooshOutPosition.top = currentTop;
      video.swooshOutPosition.left = offset.left;

      return currentTop + video.swooshOutPosition.height + 12;
    }, initialTop);
  }

  swooshSidebarVideos() {
    this.setSidebarVideoPositions();

    this.videos
      .filter(video => video.swooshed)
      .forEach(video => {
        video.swooshing = true;
        video.$iframe.animate(
          video.swooshOutPosition,
          () => (video.swooshing = false),
        );
      });
  }

  stickSidebarVideos() {
    this.optimizeSidebarVideoOffset();
    this.setSidebarVideoPositions();
    this.videos
      .filter(video => video.swooshed && !video.swooshing)
      .forEach(video => video.$iframe.css(video.swooshOutPosition));
  }

  swooshIn(video) {
    video.swooshed = false;
    video.triggerSwooshInAnimation(400);
    this.swooshSidebar();
  }

  swooshOut(video) {
    video.swooshed = true;
    video.$iframe.css({
      position: 'fixed',
      top: video.originalPosition.top,
      left: video.originalPosition.left,
    });
    const width = this.$sidebarVideos.width();
    const vpos = video.originalPosition;
    video.swooshOutPosition = {
      width,
      height: parseFloat(vpos.height) * (width / parseFloat(vpos.width)),
      top: 0,
      left: 0,
    };
    this.swooshSidebar();
  }
}
